import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useCourierServices } from '../../hooks';
import { CourierModel } from '../../models/Courier';
import { ServicesList } from './ServicesList';

interface CourierAccordionProps {
    courier: CourierModel;
}

export const CourierAccordion = ({ courier }: CourierAccordionProps) => {
    const { t } = useTranslation('coverageZonesModule');

    // Cargar servicios automáticamente (siempre desplegado)
    const { services, isLoading, error } = useCourierServices({
        courierId: courier.id,
        enabled: true, // Siempre cargados
    });

    return (
        <div className="border border-border rounded-lg mb-4 bg-card transition-colors overflow-hidden">
            {/* Header del Courier */}
            <div className="px-4 py-3 bg-muted/30 border-b border-border">
                <div className="flex items-center gap-3">
                    {courier.image_url ? (
                        <img
                            src={courier.image_url}
                            alt={courier.name}
                            className="h-10 w-10 object-contain rounded bg-white p-1"
                        />
                    ) : (
                        <div className="h-10 w-10 rounded bg-muted flex items-center justify-center">
                            <span className="text-xs font-semibold text-muted-foreground">
                                {courier.name.substring(0, 2).toUpperCase()}
                            </span>
                        </div>
                    )}
                    <div className="flex flex-col">
                        <span className="font-semibold text-foreground text-base">{courier.name}</span>
                        {courier.microservice_name && (
                            <span className="text-xs text-muted-foreground">
                                {courier.microservice_name}
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {/* Contenido: Servicios */}
            <div className="px-4 py-4">
                {isLoading && (
                    <div className="flex flex-col items-center justify-center py-12 space-y-3">
                        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
                        <p className="text-sm text-muted-foreground">
                            {t('loading.services')}
                        </p>
                    </div>
                )}

                {error && (
                    <div className="flex items-center gap-2 text-destructive text-sm py-4">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span>{t('error.loadServices')}</span>
                    </div>
                )}

                {!isLoading && !error && <ServicesList services={services} />}
            </div>
        </div>
    );
};
